module.exports = __webpack_public_path__ + "static/img/ma.0f82c99.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ma.png
// module id = uW4u
// module chunks = 128